import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useState } from "react";
import MainSidebar from "./MainSidebar";
import { useLocation, useNavigate } from "react-router-dom";

const AiButton = ({
  isOpen,
  setIsOpen,
  designData,
  setDesignData,
  possibleOptions,
  filters,
  setFilters,
  handleSaveMaterial,
  isPublicView,
  SetDesignDataForExistingMaterials,
  newFilter,
  setNewFilter,
  state = {},
  selectedProjectImage,
  setSelectedProjectImage,
  areas,
  setAreas,
  setAiRecommendations,
  aiRecommendations,
  handleStepBack,
  aiImageLoading,
  setAiImageLoading,
  projectSearch,
  setProjectSearch,
}) => {
  const [step, setStep] = useState(state?.step ? state?.step : 2);
  useEffect(() => {
    !state?.step && setStep(2);
  }, [isOpen]);
  const nav = useNavigate();
  const location = useLocation();
  return (
    <>
      {/* AI Button */}
      <div
        className="p-4 rounded-full bg-teal-600 fixed bottom-4 left-4 hover:bg-teal-700 transition-colors cursor-pointer z-10"
        onClick={() => {
          setIsOpen(!isOpen);
          setAiRecommendations([]);
          setSelectedProjectImage(null);
        }}
      >
        <Icon icon={"mingcute:ai-line"} color="white" width={"28"} />
      </div>

      {/* Sidebar */}
      <div
        className={`fixed top-0 left-0 h-full bg-white shadow-lg z-[100] transition-all duration-300 ease-in-out overflow-hidden ${
          isOpen
            ? "w-[364px] translate-x-0 opacity-100"
            : "w-0 -translate-x-[110%] opacity-0"
        }`}
      >
        <div className="p-4 flex flex-col h-full">
          {/* Close button */}
          <div className="flex justify-between mb-4 items-center">
            <div className="flex items-center gap-2">
              {step > 2 && (
                <span
                  className="cursor-pointer"
                  onClick={() => {
                    setStep((p) => p - 1);
                    handleStepBack(step, step - 1);
                  }}
                >
                  <Icon
                    icon="ep:back"
                    width={20}
                    color="black"
                    className="cursor-pointer"
                  />
                </span>
              )}
              <h2 className=" font-bold">Design Assistant</h2>
            </div>
            <button
              onClick={() => {
                setIsOpen(false);
                setAiRecommendations([]);
                setSelectedProjectImage(null);
                setNewFilter({
                  search: "",
                  brands: [],
                  types: [],
                  zone: [],
                });
                setFilters({
                  zone: [],
                  section: [],
                  material: [],
                });
                nav(`${location.pathname}${location.search}`, {
                  state: null,
                  replace: true,
                });
              }}
              className="p-2 hover:bg-gray-100 rounded-full transition-colors"
            >
              <Icon icon="material-symbols:close" width={24} color="black" />
            </button>
          </div>

          {/* Sidebar content */}
          <div className={`${isOpen ? "block" : "hidden"} grow h-full min-h-0`}>
            <MainSidebar
              designData={designData}
              setDesignData={setDesignData}
              isOpen={isOpen}
              possibleOptions={possibleOptions}
              filters={filters}
              setFilters={setFilters}
              handleSaveMaterial={handleSaveMaterial}
              isPublicView={isPublicView}
              SetDesignDataForExistingMaterials={
                SetDesignDataForExistingMaterials
              }
              newFilter={newFilter}
              setNewFilter={setNewFilter}
              state={state}
              selectedProjectImage={selectedProjectImage}
              setSelectedProjectImage={setSelectedProjectImage}
              step={step}
              setStep={setStep}
              areas={areas}
              setAreas={setAreas}
              setAiRecommendations={setAiRecommendations}
              aiRecommendations={aiRecommendations}
              aiImageLoading={aiImageLoading}
              setAiImageLoading={setAiImageLoading}
              projectSearch={projectSearch}
              setProjectSearch={setProjectSearch}
              // handleStepBack={handleStepBack}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AiButton;
